try {
  window._ = require('lodash');
  window.$ = window.jQuery = require('jquery');
  window.axios = require('axios');
  window.moment = require('moment');
  
moment.locale('pt-br');
  window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.WordPress.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
  };
} catch (e) {}



// WEBPACK FOOTER //
// ./src/bootstrap.js